.mainContainer {
  position: relative;
}

.hidden {
  display: none;
}

.radioRoot {
  height: 100%;
}

.expandButtonPlaceholder {
  width: 20px;
}

.selectActionsInlineContainer {
  min-height: var(--spacingXl); // Checkbox height
}

.checkboxRoot {
  padding: 0;
}
